import { useEffect, useState } from "react";
import { db } from "../services/firebase";
import { ref, onValue } from "firebase/database";

/**
 * ✅ Fetch all interviews under a pack (real-time updates)
 */
export default function useFetchInterviews(domainId, packId) {

    const [interviews, setInterviews] = useState([]);
    const [loadingInterviews, setLoading] = useState(true);

    useEffect(() => {
        if (!domainId || !packId) { 
            return;
        }

        const interviewsRef = ref(db, `Interviews/${domainId}/${packId}`);

        const unsubscribe = onValue(interviewsRef, (snapshot) => {

            const data = snapshot.val();
            
            if (data) {
                const arr = Object.entries(data).map(([id, value]) => ({
                    id,
                    ...value,
                }));
                arr.sort((a, b) => (a.orderId || 0) - (b.orderId || 0));
                setInterviews(arr);
            } else {
                setInterviews([]);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, [domainId, packId]);

    return { interviews, loadingInterviews };
}
